import React, { useEffect, useState } from 'react';
import { Form, Input, Cascader } from 'antd';
import FilterBoxes from '@/components/filter-boxes';
import TimestampRangePicker from '@/components/timestamp-RangePicker';
import apis from '../../apis';
import { getQuery } from '@/common/utils';

const FilterForm = (props) => {
  const [form] = Form.useForm();
  const [categoryList, setCategoryList] = useState([]);
  const channelIdQuery = getQuery('channelId');

  function onFinish(val) {
    const { time } = val;
    let createTimeBegin, createTimeEnd;
    if (time) {
      createTimeBegin = time.start;
      createTimeEnd = time.end;
    }
    props.updateParam({
      ...val,
      createTimeBegin,
      createTimeEnd,
      time: null,
      category: val.category && val.category.length > 0 ? val.category[val.category.length - 1] : '',
      currentPage: 1,
      pageSize: 10,
    });
  }

  /* eslint-disable */
  useEffect(() => {
    if (!channelIdQuery) return;
    form.setFieldsValue({
      keyword: channelIdQuery,
    });
  }, [channelIdQuery]);
  /* eslint -enable */

  useEffect(() => {
    apis.statisticTree({ type: 1 }).then((res) => {
      const { ret, data } = res;
      if (ret && ret === '0') {
        setCategoryList(data);
      } else {
        setCategoryList([]);
      }
    });
  }, []);

  return (
    <FilterBoxes
      form={form}
      onFinish={onFinish}
      resetButtonProps={{
        onClick: () => {
          form.resetFields();
        },
      }}
    >
      <Form.Item name="keyword" span={5} label="微频道ID/名称">
        <Input placeholder="请输入" />
      </Form.Item>
      <Form.Item name="category" span={5} label="所属类目">
        <Cascader
          fieldNames={{ label: 'name', value: 'fullPath' }}
          options={categoryList}
          placeholder="请选择"
          changeOnSelect
        />
      </Form.Item>
      <Form.Item name="ownerErp" span={6} label="组长ERP">
        <Input placeholder="请输入组长ERP" />
      </Form.Item>
      <Form.Item name="organizationName" span={6} label="所属部门">
        <Input placeholder="请输入" />
      </Form.Item>
      <Form.Item name="time" span={7} label="创建时间">
        <TimestampRangePicker nameFields={['start', 'end']} />
      </Form.Item>
    </FilterBoxes>
  );
};
export default FilterForm;
